import React from 'react';

import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import MultiMedsActions from 'components/shared/Forms/Custom/ProviderMedications/components/MultiMedsActions';

const MedicationWidgetFooter = ({ formattedData, setShow, gridApi }) => {
  return (
    <div className="ml-auto flex gap-2">
      {ia(formattedData) && <MultiMedsActions gridApi={gridApi} data={formattedData} />}

      <Button
        style="outlined"
        text="Close"
        className="!h-[34px]"
        color="neutral"
        onClick={() => setShow(false)}
      />
    </div>
  );
};
export default MedicationWidgetFooter;
